import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME, AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_NONE_NEGATIVE_CARRYOVER,
} from './constants';
import { AffiliatesNoneNegativeCarryoverHistoryEditModule } from './submodules/history-edit/AffiliateNoneNegativeCarryoverHistoryEditModule';
import { getTranslationKeys } from './translations';

export class AffiliatesNoneNegativeCarryoverModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesNoneNegativeCarryoverHistoryEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_ROUTE_NAME,
      path: ':id/none-negative-carryover',
      permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
      components: {
        AffiliatesListPage: () => import('./pages/AffiliatesNoneNegativeCarryoverPage/AffiliatesNoneNegativeCarryoverPage.vue'),
      },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_NONE_NEGATIVE_CARRYOVER, getTranslationKeys);
  }
}
